import DIContainer from 'services/DIContainer';
import { OrderTypeResponseDTO } from 'typings/dto/orderType';
import Mapper from './Mapper';

export default class OrderTypeMapper extends Mapper<OrderType, OrderTypeResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers, private currentUserGetter: () => User | null) {
    super({
      name: 'name',
      logoId: 'logo',
      technicalName: 'technicalName',
    });
  }

  public responseDTOToModel(dto: OrderTypeResponseDTO): OrderType {
    return {
      ...this.responseDTOToModelViaDiffMap(dto),
      technicalName: dto.technicalName,
    };
  }

  // Этот маппер по умолчанию используется при запросе данных для фильтра, а там нужен descriptionsInDropdown
  public responseDTOToModelIdAndNamesOnly = (dto: OrderTypeResponseDTO): OrderType => {
    return this.responseDTOToModel(dto);
  };
}
